"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableCandidateCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const elements_1 = require("../../elements");
const Body = (0, styled_1.default)(elements_1.Flex)(({ isOpen }) => ({
    flexDirection: 'column',
    border: constants_1.theme.border.style.thinLight,
    borderRadius: constants_1.theme.border.radius.normal,
    background: isOpen ? constants_1.Color.LIGHT_GREY : constants_1.Color.WHITE,
    transition: 'all 0.1s ease-out',
    ':hover': {
        background: constants_1.Color.LIGHT_GREY,
        border: constants_1.theme.border.style.thinDark,
    },
}));
const ToggleIcon = (0, styled_1.default)(elements_1.Icon)((props) => ({
    transform: props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.3s ease-out',
}));
const ExpandableCandidateCard = (props) => {
    return ((0, jsx_runtime_1.jsxs)(Body, { isOpen: props.isOpen, children: [(0, jsx_runtime_1.jsx)(elements_1.Clickable, { onClick: () => props.onClick(!props.isOpen), styles: { minHeight: 52, py: 2, pl: 2.5, pr: 3 }, children: (0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 2.5, styles: {
                        flexDirection: 'row-reverse',
                        justifyContent: 'space-between',
                    }, children: [(0, jsx_runtime_1.jsx)(ToggleIcon, { name: "ChevronDownIcon", size: "md", isOpen: props.isOpen }), props.header] }) }), (0, jsx_runtime_1.jsx)(elements_1.ContentChangeTransition, { transitionTrigger: props.isOpen, children: props.isOpen && ((0, jsx_runtime_1.jsx)(elements_1.Div, { styles: { px: 2.5, pb: 2 }, children: props.children })) })] }));
};
exports.ExpandableCandidateCard = ExpandableCandidateCard;
